import { useEffect } from "react";
import { writeAnim } from "./Item.js";

export default function LoadScreen({ message }) {
  useEffect(() => {
    writeAnim(message, document.querySelector(".load-wrapper h1"), 50);
  }, []);
  const pStyle = {
    textAlign: "center",
  };
  return (
    <div className="load-wrapper df w100">
      <h1 className="blink-underscore" style={pStyle}></h1>
    </div>
  );
}

export function LoadScreen2(msg = "", flag) {
  if (flag) {
    const wrapper = document.createElement("div");
    wrapper.setAttribute("class", "load-wrapper df w100");
    const message = document.createElement("h3");
    message.setAttribute("class", "blink-underscore");

    wrapper.appendChild(message);
    document.body.appendChild(wrapper);
    writeAnim(msg, message, 50);
  } else {
    document.querySelector(".load-wrapper").remove();
  }
}
